<template>
    <div class="card">
        <div class="bg-blue-light p-1">
            <TitleButton 
                :showBtn="false"
                title="My Attendance"
                :showAddNew="true"
                :btnTitle="'Add New'"
                @onClickAddNewButton="onClickAddNewButton"
            />
        </div>
        <div class="my-2 px-2">
            <DateQuerySetter
                btnTitle="Go"
                @onClickGo="onClickToGo"
                class="tds-vds-query-setter"
            >
            </DateQuerySetter>
        </div>

        <div class="col-12 px-3">
          <div class="d-flex justify-content-end align-items-center mb-1">
            <strong class="me-3">Total Expense Claim: {{ totalExpenseClaim }}</strong>
            <button
                @click="goToPrint"
                :disabled="loading"
                class="btn btn-outline-secondary btn-sm btn-download-invoice waves-effect"
            >
              Print
            </button>
          </div>
        </div>

        <div class="col-12 px-2 mb-4">
            <ListTable :tableItems="tableItems" :formData="formData" :getAttendanceList="getAttendanceList" />
        </div>

        <Loader v-if="loading"/>

      <ManualAttendanceModal
          v-if="store.state.isModalOpenTwo"
          :formData="formData"
          @getAttendanceList="getAttendanceList"
      />

    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import { inject, onMounted, reactive, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import ListTable from '@/components/molecule/company/hrm-payroll/my-attendance/ListTable.vue';
import ManualAttendanceModal from '@/components/molecule/company/hrm-payroll/my-attendance/ManualAttendanceModal.vue';
import DateQuerySetter from '@/components/atom/DateQuerySetter.vue';
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import handleCompany from "@/services/modules/company";
import attendancePdf from '@/services/utils/pdf/attendancePdf';
import { computed } from 'vue';

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false)
const tableItems = ref([]);
const totalExpenseClaim = ref(0);
const params = ref({
    offset: 30,
});

const token = computed(() => localStorage.getItem('token'));
let companyInfo = reactive({})

const {
  fetchAttendanceList,
} = handleHrPayroll()
const { fetchCompanyInfo } = handleCompany();
const { exportToPDF } = attendancePdf();

const formData = ref({
  in_time:null,
  out_time:null,
  remarks:null,
  is_edit:false,
})

const onClickToGo = () => {
   getAttendanceList();
}

function onClickAddNewButton() {
  store.state.isModalOpenTwo = true
}

const getAttendanceList = async () => {
    const query = getQuery();
    loading.value = true
    tableItems.value = []

    await fetchAttendanceList(query).then(res => {
        if (!res.status){
            return
        }

        tableItems.value = res.data;
        totalExpenseClaim.value = res.total_expense_claim;
    }).catch(err => {
    }).finally(() => {
        loading.value = false
    })
}

const getQuery = () => {
    let query = `?company_id=${route.params.companyId}`;
    if (route.query.page) query += '&page=' + route.query.page;
    if (route.query.start) query += '&start_date=' + route.query.start;
    if (route.query.end) query += '&end_date=' + route.query.end;
    query += '&offset=' + params.value.offset
    return query;
}

const setCompanyInfo = async () => {
  await fetchCompanyInfo(route.params.companyId).then((res) => {
    companyInfo = res.data;
  }).catch((error) => {
  });
}

const goToPrint = () => {
    exportToPDF(companyInfo, tableItems.value, totalExpenseClaim.value);
}

onMounted(() => {
    Promise.all([
         getAttendanceList(),
         setCompanyInfo(),
    ])
})
</script>
